;(function() {
function MojaFirmaService(IndexService, $window) {

    let backendService = IndexService;

    return {
        goToMojaFirma
    };

    function goToMojaFirma(path) {
        backendService.getMojaFirmaUrl(path).then(data => {
            $window.location = data;
        }).catch();
    }
}

angular.module("firmaren")
    .service("MojaFirmaService", MojaFirmaService);
}());
